import React from 'react';

import { ReportBugsContext } from '@qality/common-components/src/lib/ReportBugsProvider';

import { ReportedBugsListView } from './ReportedBugsList.view';

type Props = {
  readOnly: boolean;
};

export const ReportedBugsList = ({ readOnly }: Props): JSX.Element => {
  const { isLoading, notFetchedCount, issues, removeByIssueId } =
    React.useContext(ReportBugsContext);

  const handleRemoveIssue = (issueId) => {
    removeByIssueId(issueId);
  };

  return (
    <ReportedBugsListView
      errorsCount={notFetchedCount}
      isLoading={isLoading}
      issuesList={issues}
      onRemove={handleRemoveIssue}
      readOnly={readOnly}
    />
  );
};
